<script>
import { generate } from 'randomstring';

import ScrollGradient from './ScrollGradient';
import Product from './Product';

export default {
  components: {
    Product,
    ScrollGradient,
  },
  props: {
    text: String,
    campaigns: Array,
    utmSource: String,
    affiliate: String,
    currencyInfo: Object,
    hidePrice: [String, Boolean],
    wrap: [String, Boolean],
    type: String,
    isWhitelabel: Boolean,
    threeColumns: [String, Boolean], // only applies when wrap is set to true
    coupon: String,
  },
  data: () => ({
    generate,
  }),
  computed: {
    marginClass() {
      let classes = '';

      switch (this.type) {
        case 'sales':
          classes = 'my-3';
          break;
        case 'cart':
          break;
        default:
          break;
      }

      return classes;
    },
    textClass() {
      let classes = [];

      switch (this.type) {
        case 'sales':
          classes = 'mx-1_5 md_mx-1 mb-1 text-3xl';
          break;
        case 'cart':
          classes = 'text-2xl mx-1_5 md_mx-1 mb-1';
          break;
        default:
          classes = 'mx-2_25 md_mx-1 text-4xl md_text-3xl';
          break;
      }

      return classes;
    },
  },
};
</script>

<template lang='pug'>
.w-full(:class='marginClass')
  .text-brand-secondary-900.font-bold(
    v-if='text',
    :class='textClass',
  ) {{text.capitalize()}}
  .relative
    scroll-gradient(
      :hidden='wrap',
      :class='{\
        "flex flex-wrap": wrap,\
        "md_flex ml-_375 overflow-x-auto md_overflow-x-visible whitespace-no-wrap md_whitespace-normal": !wrap,\
        "px-1": wrap && isWhitelabel,\
        "px-1 pt-1 md_pt-2 md_px-2": wrap && !isWhitelabel,\
      }',
    )
      product(
        v-for='(campaign, index) in campaigns',
        :class='[\
          { "md_w-1-4 ": !wrap },\
          { "w-1-2 md_w-1-3": wrap },\
          { "lg_w-1-4": wrap && !threeColumns },\
          { "ml-1 md_ml-_5": index === 0 && !wrap },\
        ]',
        :hide-price='hidePrice',
        :utm-source='utmSource',
        :affiliate='affiliate',
        :campaign='campaign',
        :currency-info='currencyInfo',
        :key='generate()',
        :wrap='wrap',
        :three-columns='threeColumns',
        :is-whitelabel='isWhitelabel',
        :coupon='coupon',
        @hide-campaign='$emit("hide-campaign", $event)',
      )
</template>

<style>
</style>